module.exports = __webpack_public_path__ + "img/2_2_1.4ba84a53.jpg";